import { gql } from '@moonpig/web-core-graphql'

export const ModuleCarouselFragment = gql`
  fragment ModuleCarousel on ModuleCarousel {
    title
    items {
      __typename
      ...ModuleHero
      ...ModuleFacetTile
    }
  }
`
